import {
  ProductDepartmentAutocompleteDocument,
  type ProductDepartmentAutocompleteQuery,
  type ProductDepartmentAutocompleteQueryVariables,
} from "@/generated/graphql";
import type { AutocompleteFetchResult } from "@k3-tech/react-kit";
import { useCallback } from "react";
import { useClient } from "urql";

export const useProductDepartmentAutocomplete = () => {
  const urqlClient = useClient();

  const load = useCallback(
    async (page: number, pageSize: number, search: string) => {
      const { data } = await urqlClient
        .query<
          ProductDepartmentAutocompleteQuery,
          ProductDepartmentAutocompleteQueryVariables
        >(
          ProductDepartmentAutocompleteDocument,
          {
            qop: {
              pagination: {
                page,
                pageSize,
                withCount: true,
              },
              filters: { productDepartmentName: search },
            },
          },
          { suspense: false, requestPolicy: "network-only" },
        )
        .toPromise();

      const rawItems = data?.productDepartments?.items ?? [];
      const items = (rawItems || [])
        .filter((it): it is NonNullable<typeof it> => Boolean(it))
        .map((item) => ({ value: item.productDepartmentID, label: item.productDepartmentName }));

      return {
        items: items ?? [],
        total: data?.productDepartments?.pagination?.totalRows ?? 0,
        hasMore: data?.productDepartments?.pagination?.hasNext ?? false,
      } as AutocompleteFetchResult;
    },
    [urqlClient],
  );

  return { load };
};
